import { PremiumPreviewData, PremiumPreviewType } from '../store/schema/PremiumPreviewData';
import {
    premiumPreviewDaysLeftText,
    premiumPreviewSuggestionsLeftText,
    skittleDialogTextLimitedToTime,
    premiumPreviewCalloutSuggestionsLeftText,
    premiumPreviewOneSuggestionLeftText,
    premiumPreviewOneDayLeftText,
} from '../components/SkittleCallout.locstring.json';
import { assertNever } from 'owa-assert';

export function getTextStringSkittle(
    premiumPreviewData: PremiumPreviewData,
    numberOfDays: number | null,
    numberOfSuggestions: number | null
): {
    stringToShowInSkittle: string | undefined;
    numberToShow: number;
    stringToShowOnPremiumPreviewCallout: string | undefined;
} {
    let stringToShowInSkittle: string;
    let numberToShow: number;
    let stringToShowOnPremiumPreviewCallout: string;

    const currentPremiumPreviewType: PremiumPreviewType = premiumPreviewData.premiumPreviewType;

    switch (currentPremiumPreviewType) {
        case PremiumPreviewType.TimeBased:
            stringToShowOnPremiumPreviewCallout = skittleDialogTextLimitedToTime;
            numberToShow =
                numberOfDays || premiumPreviewData.numberOfDaysLeftToUsePremiunSuggestions;
            if (numberToShow === 1) {
                stringToShowInSkittle = premiumPreviewOneDayLeftText;
            } else {
                stringToShowInSkittle = premiumPreviewDaysLeftText;
            }
            break;
        case PremiumPreviewType.CountBased:
            stringToShowOnPremiumPreviewCallout = premiumPreviewCalloutSuggestionsLeftText;

            numberToShow = numberOfSuggestions || premiumPreviewData.premiumSuggestionsCount;
            if (numberToShow === 1) {
                stringToShowInSkittle = premiumPreviewOneSuggestionLeftText;
            } else {
                stringToShowInSkittle = premiumPreviewSuggestionsLeftText;
            }
            break;
        case PremiumPreviewType.TimeAndCountCombined:
        case PremiumPreviewType.BasicSkittle:
        case PremiumPreviewType.None:
            break;
        default:
            return assertNever(currentPremiumPreviewType);
    }

    return { stringToShowInSkittle, numberToShow, stringToShowOnPremiumPreviewCallout };
}
